(function () {
  "use strict";

  function closeItem(question, answer) {
    question.setAttribute("aria-expanded", "false");
    if (answer) answer.hidden = true;
  }

  function openItem(question, answer) {
    question.setAttribute("aria-expanded", "true");
    if (answer) answer.hidden = false;
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;

    var questions = sectionEl.querySelectorAll(".cwc_ollie-faq__question");
    if (!questions.length) return;

    questions.forEach(function (question) {
      // Guard against double-binding if the section re-initializes
      if (question.dataset.cwcFaqBound === "true") return;
      question.dataset.cwcFaqBound = "true";

      question.addEventListener("click", function () {
        var answerId = question.getAttribute("aria-controls");
        var answer = answerId
          ? sectionEl.querySelector("#" + CSS.escape(answerId))
          : null;
        var isOpen = question.getAttribute("aria-expanded") === "true";

        // Close all items first (accordion behavior)
        questions.forEach(function (q) {
          var aid = q.getAttribute("aria-controls");
          var a = aid ? sectionEl.querySelector("#" + CSS.escape(aid)) : null;
          closeItem(q, a);
        });

        // Open this one only if it was closed
        if (!isOpen) {
          openItem(question, answer);
        }
      });
    });
  }

  function initAllSections() {
    document.querySelectorAll(".cwc_ollie-faq").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".cwc_ollie-faq");
    if (section) initSection(section);
  });
})();
